import { registerView } from '../viewRegistry';
import { interactiveRegistry, navigateTo } from '../interactivity';
import { getCanonicalSafeArea } from '../safeArea';
import { DopeTextRenderer } from '../renderer/bitmapFont';
import DopeUI, { TERMINAL } from '../ui/DopeOS-UI';

const APPS = [
  { id: 'market', label: 'MARKET', state: 'OPEN' },
  { id: 'tickets', label: 'TICKETS', state: 'OPEN' },
  { id: 'ledger', label: 'LEDGER', state: 'OPEN' },
  { id: 'coat', label: 'COAT', state: 'OPEN' },
  { id: 'hronir', label: 'HRONIR', state: 'OPEN' },
  { id: 'signals', label: 'SIGNALS', state: 'OPEN' },
  { id: 'story', label: 'STORY', state: 'OPEN' },
  { id: 'journal', label: 'JOURNAL', state: 'OPEN' },
  { id: 'audit', label: 'AUDITOR', state: 'OPEN' },
  { id: 'purge', label: 'PURGE', state: 'OPEN' },
  { id: 'archive', label: 'ARCHIVE', state: 'OPEN' },
];

const uiState = { notice: '' };

function text(ctx, value, x, y, color = TERMINAL.TEXT) {
  ctx.fillStyle = color;
  DopeTextRenderer.renderDOSText(ctx, value, x, y, 1);
}

function rule(ctx, x, y, w, color = TERMINAL.GREEN_DARK) {
  ctx.fillStyle = color;
  ctx.fillRect(x, y, w, 1);
}

registerView('apps', function renderApps(ctx, time, width, height) {
  interactiveRegistry.clear();
  const safe = getCanonicalSafeArea({ w: width || 640, h: height || 400 });
  ctx.fillStyle = TERMINAL.BLACK;
  ctx.fillRect(0, 0, safe.width, safe.height);

  const mobile = safe.width < 500;
  ctx.fillRect(0, 0, safe.width, 26);
  rule(ctx, 0, 25, safe.width);
  if (mobile) {
    text(ctx, 'DOPEOS // APPS', 8, 5, TERMINAL.TEXT);
    text(ctx, 'READY', safe.width - 64, 5, TERMINAL.GREEN);
  } else {
    text(ctx, 'DOPEOS // APPS', 8, 5, TERMINAL.TEXT);
    text(ctx, 'SELECT A PROCESS', 224, 5, TERMINAL.TEXT_DIM);
    text(ctx, 'READY', safe.width - 64, 5, TERMINAL.GREEN);
  }

  DopeUI.Panel(ctx, 8, 36, mobile ? safe.width - 16 : 624, mobile ? 500 : 280, 'APPLICATIONS');
  const cols = mobile ? 1 : 2;
  const cellW = mobile ? safe.width - 32 : 296;
  const cellH = mobile ? 44 : 44;
  const gap = mobile ? 0 : 8;
  APPS.forEach((app, index) => {
    const col = index % cols;
    const row = Math.floor(index / cols);
    const x = mobile ? 16 : 20 + col * (cellW + gap);
    const y = mobile ? 48 + row * (cellH + gap) : 58 + row * (cellH + gap);
    const open = app.state === 'OPEN';
    DopeUIButton(ctx, x, y, cellW, cellH, app, open);
  });

  const footerY = mobile ? 548 : 328;
  ctx.fillStyle = TERMINAL.BLACK;
  ctx.fillRect(0, footerY, safe.width, safe.height - footerY);
  rule(ctx, 0, footerY, safe.width);
  text(ctx, 'TAB FOCUS   ENTER OPEN   ESC DESKTOP', 8, mobile ? footerY + 8 : 360, TERMINAL.TEXT_DIM);
  const notice = uiState.notice || 'RECORDS // BEYOND THE STREET';
  text(ctx, notice, 8, mobile ? footerY + 20 : 384, uiState.notice ? TERMINAL.TEXT : TERMINAL.TEXT_DIM);
  const backY = mobile ? footerY + 44 : 336;
  const backX = mobile ? 8 : safe.width - 200;
  const backW = mobile ? safe.width - 16 : 192;
  const backH = mobile ? 44 : 24;
  DopeUI.Button(ctx, backX, backY, backW, backH, 'BACK TO DESKTOP', 'normal');
  interactiveRegistry.register({
    id: 'apps-back', x: backX, y: backY, w: backW, h: backH,
    onClick: () => navigateTo('main_menu'),
  });
});

function DopeUIButton(ctx, x, y, w, h, app, open) {
  DopeUI.Button(ctx, x, y, w, h, app.label, open ? 'normal' : 'disabled');
  text(ctx, open ? '[OPEN]' : '[LOCKED]', x + w - 76, y + h / 2 - 8, TERMINAL.TEXT_DIM);
  interactiveRegistry.register({
    id: `apps-${app.id}`, x, y, w, h,
    onClick: () => {
      if (open) {
        uiState.notice = '';
        navigateTo(app.id);
      } else {
        uiState.notice = `${app.label} LOCKED // COMING SOON.`;
      }
    },
  });
}
